jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('click', '.menu-toggle', function() {

        if ( $(this).hasClass('icon-menu') ) {

            $('.top-menu').addClass('visible');
            $(this).removeClass('icon-menu').addClass('icon-close');
            $('body, html').addClass('menu-open');

        } else {

            $('.top-menu').removeClass('visible');
            $(this).addClass('icon-menu').removeClass('icon-close');
            $('body, html').removeClass('menu-open');

        }

    });

    $(document.body).on('click', '.sub-menu-toggle', function() {

        $(this).next().slideToggle();
        $(this).prev().toggleClass('active');

    });



});